export default __webpack_public_path__ + "fefc267127c164bf3f8ec8a8538eb094.png";